import { ScoopTheme } from '../../../../Insights/Style'
import ReactECharts from 'echarts-for-react'

// ECharts color constants
const COLORS = {
    defaultNode: '#6B6BD6',
    tooltipBackground: '#fff',
    tooltipBorder: '#ccc',
    tooltipText: '#333',
    lineColor: '#6366F1',
    backgroundColor: 'transparent',
}

export const VisualizeTree = ({ graph, screenshot }) => {
    const targetClass = graph.targetClassValue
    const maxErr = 0.5 // treat ≥ 50 % as "completely uncertain"

    function colorByClassAndError(cls, instances, err) {
        if (instances == null || !targetClass) return COLORS.defaultNode

        const hue = cls === targetClass ? 155 : 8 // forest vs crimson
        const satFull = cls === targetClass ? 60 : 55 // max saturation
        const satMin = cls === targetClass ? 25 : 20 // min saturation

        // linear desaturation 0 → maxErr
        const sat = err ? satFull - (satFull - satMin) * Math.min(err / maxErr, 1) : satFull

        const light = cls === targetClass ? 45 : 48 // keep tone distinct
        return `hsl(${hue}, ${sat}%, ${light}%)`
    }

    // walk once to find the biggest leaf count
    let maxInst = 0

    function findMax(n) {
        if (typeof n !== 'object' || n === null) return // ← guard
        if (n.instances != null) maxInst = Math.max(maxInst, n.instances)
        if (n.children) n.children.forEach(findMax)
    }

    findMax(graph)

    // Recursively inject itemStyle.color into every node
    function applyColors(node) {
        if (typeof node !== 'object' || node === null) return
        node.itemStyle = {
            color: colorByClassAndError(node.classLabel, node.instances, node.errorRate),
        }
        if (node.children) node.children.forEach(applyColors)
    }

    applyColors(graph)

    function roundedRectPath(r = 10) {
        return `M${r},0H90a${r},${r} 0 0 1 ${r},${r}V90a${r},${r} 0 0 1-${r},${r}H${r}a${r},${r} 0 0 1-${r}-${r}V${r}a${r},${r} 0 0 1 ${r}-${r}Z`
    }

    const smoothRect = roundedRectPath(35)

    const tooltip = {
        trigger: 'item',
        confine: true, // keep it inside the chart area
        backgroundColor: COLORS.tooltipBackground,
        borderColor: COLORS.tooltipBorder,
        borderWidth: 1,
        textStyle: { color: COLORS.tooltipText, fontSize: 12 },
        formatter: ({ data }) => {
            // build any HTML you like; `data` is the node object you passed in
            return (
                `
        <div style="min-width:160px">
          <strong>${data.name}</strong><br/>` +
                (data.instances
                    ? `Instances: ${data.instances}` +
                      (data.errorRate
                          ? `<br/>Error rate: ${(data.errorRate * 100).toFixed(1)}` + '%'
                          : '')
                    : '') +
                `</div>`
            )
        },
    }
    let nodeHeight = 25

    let option = {
        tooltip,
        series: [
            {
                type: 'tree',

                initialTreeDepth: 1,
                roam: true,
                orient: 'LR',
                data: [graph],
                symbol: 'path://' + smoothRect,
                symbolSize: [170, nodeHeight],
                edgeShape: 'curve',
                lineStyle: { width: 2, color: COLORS.lineColor },
                label: {
                    position: 'inside',
                    fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
                    fontSize: 9,
                    fontWeight: 500,
                    lineHeight: 12,
                    formatter: (p) => {
                        const d = p.data
                        const name = d.edgeLabel ? `${d.edgeLabel}\n${d.name}` : d.name
                        //                        if (d.instances == null) return name;
                        //                        const counts = `${d.instances}`;
                        //                        return counts ? `${name}\n${counts}` : name;
                        return name
                    },
                },
                animationDuration: 800,
            },
        ],
        backgroundColor: COLORS.backgroundColor,
    }

    // Largest level size - to determine height
    let maxCount = 0
    for (let i = 0; i < graph.levelSizes.length && i < 2; i++) {
        if (graph.levelSizes[i] > maxCount) {
            maxCount = graph.levelSizes[i]
        }
    }
    let height = Math.max(400, Math.min(1200, maxCount * nodeHeight))

    return (
        <ReactECharts
            style={{ height: screenshot ? '100%' : height }}
            option={option}
            notMerge={true}
            lazyUpdate={true}
            theme={ScoopTheme}
        />
    )
}
